<template>
  <LvStateDropdownRadioInputAvatar001
    v-model="state"
    outline
    avatar-select
    required
    title="覆核人員"
    leading-icon="icon-outline-perm-identity"
    rules="required"
    placeholder="覆核人員覆核人員"
  />
</template>

<script>
export default {
  data() {
    return {
      state: null
    }
  }
}
</script>